<template>
	<div
		class="spotlight-result"
		:class="{ 'action-label': actionLabel }"
		tabindex="0"
		@click="$emit('select')"
		@keydown.enter="$emit('select')"
	>
		<div class="result-image">
			<img
				v-if="image"
				:src="image"
				:alt="title"
			/>
			<IconSvg
				v-else-if="icon"
				:name="icon"
			/>
		</div>
		<div class="result-content">
			<div class="result-title">{{ title }}</div>
			<div
				v-if="description"
				class="result-description"
			>
				{{ description }}
			</div>
			<div
				v-if="meta"
				class="result-meta"
			>
				{{ meta }}
			</div>
		</div>
		<div
			v-if="actionLabel || actionIcons"
			class="result-action"
		>
			<IconSvg
				v-for="(actionIcon, index) in actionIcons"
				:key="index"
				class="colored"
				:name="actionIcon"
			/>
			{{ actionLabel }}
		</div>
	</div>
</template>

<script lang="ts">
import Vue from 'vue'
import IconSvg from '@cv/components/atoms/IconSvg.vue'

export default Vue.extend({
	name: 'SpotlightSearchResult',
	components: {
		IconSvg
	},
	props: {
		image: {
			type: String,
			required: false
		},
		icon: {
			type: String,
			required: false
		},
		title: {
			type: String,
			required: true
		},
		description: {
			type: String,
			required: false
		},
		meta: {
			type: String,
			required: false
		},
		actionLabel: {
			type: String,
			required: false
		},
		actionIcons: {
			type: Array,
			required: false
		}
	}
})
</script>

<style lang="less" scoped>
@import '../../less/variables';

.spotlight-result {
	display: flex;
	align-items: center;
	gap: 0.75rem;
	padding: 0.75rem;
	border-radius: 8px;
	cursor: pointer;
	transition: background-color 0.15s;
	outline: none;
	margin-bottom: 0.25em;
	&:hover {
		background-color: @grayLight;
	}
	&.is-active {
		box-shadow: inset 0 0 0 2px var(--color-brand-accent);
	}
}

.result-image {
	width: 3em;
	height: 3em;
	flex-shrink: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 3px;
	background-color: @grayExtraLight;
	img {
		width: 100%;
		height: 100%;
		border-radius: 6px;
		object-fit: cover;
	}
	.icon-svg {
		width: 16px;
		height: 16px;
		color: @grayMedium;
	}
}

.result-content {
	flex: 1;
	min-width: 0;
}

.result-title {
	font-weight: 500;
	font-size: 0.9rem;
	line-height: 1.3;
	color: @grayDark;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.result-description {
	font-size: 0.8rem;
	line-height: 1.3;
	color: @grayMedium;
	margin-top: 0.1rem;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.result-meta {
	font-size: 0.7rem;
	line-height: 1.2;
	color: @grayLightMedium;
	margin-top: 0.1rem;
}

.result-action {
	line-height: 1.3;
	color: @grayMedium;
	margin-top: 0.1rem;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	display: flex;
	gap: 0.5em;
	.icon {
		font-size: 1.5rem;
	}
}
.action-label .result-action {
	font-size: 0.8rem;
	.icon {
		font-size: 1rem;
	}
}
</style>
